const defaults={quantity:null,budgetBasis:'unknown',targetBudget:'',maximumBudget:'',budgetDisclosure:'unknown',payer:'unknown',taxAndShipping:'unknown',inHandsDate:'',deadlineFlexibility:'unknown',occasion:'',successDefinition:'',priorities:[],mustHaves:'',incumbentStatus:'unknown',incumbentVendor:'',incumbentStrengths:'',incumbentPainPoints:'',decisionMaker:'',otherStakeholders:'',approvalProcess:'',notes:''}
export function discoveryFormForJob(job){return {...structuredClone(defaults),...structuredClone(job.discoveryGuide?.data||job.discovery?.data||{})}}
const same=(a,b)=>JSON.stringify(a)===JSON.stringify(b)
const comparable=(key,value)=>{
  if(key==='targetBudget'||key==='maximumBudget'){
    const text=String(value??'').trim()
    if(text==='')return null
    if(/^\d+(?:\.\d{1,2})?$/.test(text))return Math.round(Number(text)*100)
    return text
  }
  if(key==='quantity')return value==null||value===''?null:Number(value)
  if(typeof value==='string')return value.trim()
  return value
}
export function discoveryAnswerPatch(initial,current){return Object.fromEntries(Object.keys(defaults).filter(key=>!same(comparable(key,initial[key]),comparable(key,current[key]))).map(key=>[key,current[key]]))}
export function updateDiscoveryAnswer(form,key,value){
  const next={...form,[key]:value}
  if(key==='budgetBasis'&&form.budgetBasis!==value){next.targetBudget='';next.maximumBudget=''}
  if(key==='budgetDisclosure'&&value==='declined'){next.targetBudget='';next.maximumBudget=''}
  return next
}
export const budgetDisplay=cents=>cents==null?'Not recorded':new Intl.NumberFormat('en-US',{style:'currency',currency:'USD'}).format(cents/100)
